module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.breakdown) ? _c('table', {
    staticClass: "ui table",
    class: _vm.data.area
  }, [_c('thead', [(_vm.data.type === 'bars') ? _c('tr', [_c('th', [_vm._v("Month")]), _vm._v(" "), _c('th', [_vm._v("Total")])]) : _vm._e(), _vm._v(" "), (_vm.data.type === 'list') ? _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.data.valueName))])]) : _vm._e()]), _vm._v(" "), _c('tbody', [_vm._l((_vm.data.detail), function(m) {
    return (_vm.data.type === 'bars') ? _c('tr', [_c('td', [_vm._v(_vm._s(m.month))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.total))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.data.sortedList), function(m) {
    return (_vm.data.type === 'list') ? _c('tr', [_c('td', [_vm._v(_vm._s(m.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.value))])]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.breakdown) ? _c('table', {
    staticClass: "ui table",
    class: _vm.data.area
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Month")]), _vm._v(" "), _vm._l((_vm.breakdown.values), function(v) {
    return (v.on) ? _c('th', [_vm._v(_vm._s(v.name))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.data.detail), function(m) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(m.month))]), _vm._v(" "), _vm._l((_vm.breakdown.values), function(v) {
      return (v.on) ? _c('td', [_vm._v(_vm._s(m.breakdowns[_vm.breakdown.name][v.name]))]) : _vm._e()
    })], 2)
  }))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c2da9656"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableChart.vue
// module id = 398
// module chunks = 1